<div id="contentSSOLogin" class="content-sso-login" style="width: 500px;">

</div>

